import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
                <div className="skeleton h-6 w-32 rounded" />
            </div>
        );
    }
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
};
